export default {
  SET_LIST(state, data) {
    state.products = data;
  },
  CLEAR_PRODUCT(state) {
    state.products = [];
  },
};
